import React from 'react';
import Icon from '../../../components/AppIcon';

const CompetitiveAnalysisPanel = ({ data }) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-6">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
        Competitive Analysis
      </h2>

      {/* Competitors */}
      <div className="mb-6">
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
          Competitor Tracking
        </h3>
        <div className="space-y-3">
          {data?.competitors?.map((competitor, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm text-gray-900 dark:text-white">
                    {competitor?.name}
                  </span>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {competitor?.mentions} mentions
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex-1 h-2 bg-gray-200 dark:bg-slate-700 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-emerald-500"
                      style={{ width: `${competitor?.winRate}%` }}
                    />
                  </div>
                  <span className="text-xs font-medium text-gray-900 dark:text-white">
                    {competitor?.winRate}%
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Win Factors */}
      <div className="mb-6">
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2">
          <Icon name="CheckCircle" size={16} className="text-emerald-600" />
          Win Factors
        </h3>
        <ul className="space-y-2">
          {data?.winFactors?.map((factor, index) => (
            <li key={index} className="text-xs text-gray-600 dark:text-gray-400 flex items-start gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mt-1.5 flex-shrink-0" />
              {factor}
            </li>
          ))}
        </ul>
      </div>

      {/* Loss Factors */}
      <div>
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2">
          <Icon name="XCircle" size={16} className="text-red-600" />
          Loss Factors
        </h3>
        <ul className="space-y-2">
          {data?.lossFactors?.map((factor, index) => (
            <li key={index} className="text-xs text-gray-600 dark:text-gray-400 flex items-start gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-red-500 mt-1.5 flex-shrink-0" />
              {factor}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CompetitiveAnalysisPanel;